module.exports = __webpack_public_path__ + "static/media/akashResume.01f8419d.pdf";